import { Component, Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './synthetic-view.component.ajs';

@Directive({
  selector: 'cng-hypervision-synthetic-upgrade',
})
export class HypervisionSyntheticUpgradeComponent extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-hypervision-synthetic',
  template: '<cng-hypervision-synthetic-upgrade></cng-hypervision-synthetic-upgrade>',
})
export class HypervisionSyntheticComponent {}
